import {Component,Input} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {MenuServices} from "../../services";
import {Globals} from "../../../../globals";
import {DishServices} from "../../../dish/services";
import { ConfigurationImagesPage } from '../../../configuration/configuration-images/configuration-images';
import { TranslateService } from '@ngx-translate/core';


/**
 * Generated class for the MenuPartialCustomizeViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-menu-partial-customize-view',
    templateUrl: 'menu-partial-customize-view.html',
})
export class MenuPartialCustomizeViewPage {
    @Input() menu_uid: any ;
    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public menuServices: MenuServices,
                public globals: Globals,
                public dishServices: DishServices,
                public translate: TranslateService) {

        }

    setStylesP(section){
        let styles = {
            'text-align': section.text_align,
            'font-family': section.font_family,
            'color': section.font_color,
            'word-wrap': 'break-word',
            'margin-bottom': '0px',
        };
        return styles;
    }

    setStylesSpan(section){
        let styles = {
            'font-size': section.font_size+'px',
        };
        return styles;
    }

    styleA4(menu){
        //Simulacion de la hoja de papel A4. Propocionalmente le ponemos la medida
        var width_div = document.getElementById('paper_sheet').offsetWidth;
        //Regla de 3 para encontrar la parte propocional para tener un A4 en pantalla.
        var base_width = 595.276; //A4
        var base_height = 841.89; //A4
        var percent = width_div * 100 / base_width;
        var height_div = base_height * percent / 100;
        let styles = {
            'height': height_div+'px',
            'background-position': 'center',
            'background-repeat': 'no-repeat',
            '-webkit-background-size': 'cover',
            '-moz-background-size': 'cover',
            '-o-background-size': 'cover',
            'background-size': 'cover',
        };

        return styles;

    }

    setStylesHeaderTitle(menu){
        let styles = {
            'text-align': menu.header_text_align,
            'font-family': menu.header_font_family,
            'color': menu.header_font_color,
            'font-size': menu.header_font_size+'px',
            'word-wrap': 'break-word',
            'margin-bottom': '0px',
        };
        return styles;
    }
    setStylesHeaderSubTitle(menu){
        var _size = menu.header_font_size - 8;
        let styles = {
            'text-align': menu.header_text_align,
            'font-family': menu.header_font_family,
            'color': menu.header_font_color,
            'font-size': _size+'px',
            'word-wrap': 'break-word',
        };
        return styles;
    }

    setStyleFont(size){
        let styles = {
            'font-size': size+'px',
        };
        return styles;
    }

    setStylesFooter(menu){
        let styles = {
            'text-align': menu.footer_text_align,
            'font-family': menu.footer_font_family,
            'color': menu.footer_font_color,
            'font-size': menu.footer_font_size+'px',
            'word-wrap': 'break-word',
            'margin-bottom': '0px',
        };
        return styles;
    }

    edit(value,index){
        this.menuServices.edit = true;
        this.menuServices.edit_section = value;
        this.menuServices.edit_index = index;
        this.menuServices.edit_dish_array = this.globals.objectToArray(this.menuServices.edit_section.dish);
        this.menuServices.edit_type = 'dish';
    }

    editHeader(){
        this.menuServices.edit = true;
        this.menuServices.edit_type = 'header';
    }
    editFooter(){
        this.menuServices.edit = true;
        this.menuServices.edit_type = 'footer';
    }

    uploadImage(){
        this.globals.side_menu_config_active = 'images';
        this.navCtrl.push(ConfigurationImagesPage);
    }

}



// WEBPACK FOOTER //
// ./src/pages/menu/menu-view/menu-partial-customize-view/menu-partial-customize-view.ts